import { HeroTask, IHero } from "./shared/IHero";
import { DropItemCategory, IDropItemDefinition, TroopTrait } from "./shared/JsonDefinitions";

export function getTraitGlyph(trait?: TroopTrait): string {
    switch (trait) {
        case TroopTrait.Footman: return "👣";
        case TroopTrait.Mounted: return "🐎";
        case TroopTrait.Ranged: return "🏹";
        default: return "🚫";
    }
}

export function getStarsGlyph(stars: number): string {
    return "⭐".repeat(stars);
}

export function getHeroImage(hero: IHero): string {
    return `/assets/heroes/${hero.id.toString().padStart(2, '0')}.webp`;
}

export function getHeroTaskGlyph(task: HeroTask): string {
    switch (task) {
        case HeroTask.Guard: return "🛡️";
        case HeroTask.Attack: return "⚔️";
        case HeroTask.Production: return "⛏️";
        case HeroTask.Population: return "👥";
        default: return "💤";
    }
}

export function getShortTroopName(name: string): string {
    const shortName = name.includes(" ") ? name.split(" ")[1] : name;
    return shortName;
}

export function getItemDropImage(item: IDropItemDefinition): string {
    const textureName = "/assets/drops/" +
        (item.category == DropItemCategory.Resource ? "resources" :
         item.category == DropItemCategory.Material ? "materials" :
         item.category == DropItemCategory.Equipment ? "equipment" : "buffs") +
        "/" + item.id + ".png";
    return textureName;
}